import { useSyncExternalStore } from 'react';

/** Минимальное наблюдаемое значение для сервисов (сессия, язык, тема, маршрут). */
export class Observable<T> {
  private readonly listeners = new Set<() => void>();

  constructor(private value: T) {}

  get(): T {
    return this.value;
  }

  set(next: T): void {
    if (Object.is(next, this.value)) return;
    this.value = next;
    for (const listener of this.listeners) listener();
  }

  subscribe = (listener: () => void): (() => void) => {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  };
}

export function useObservable<T>(observable: Observable<T>): T {
  return useSyncExternalStore(observable.subscribe, () => observable.get(), () => observable.get());
}
